import React, { useContext, useEffect, useState } from 'react';
import RingilSidebar from '@components/ringil3/Sidebar/RingilSidebar';
import Label from '../Form/Label/Label';
import { InputText } from 'primereact/inputtext';
import * as yup from 'yup';
import ValidationDiv from '@utils/validation';
import useTranslation from '@hooks/i18n/useTranslation.tsx';
import { ApiContext } from '@api/api.tsx';
import useValidation from '@hooks/validation-hook/useValidation.tsx';

interface ComponentProps {
  visible: boolean;
  onHide: () => void;
  phoneNumber: string;
  onComplete: () => void;
}

const EditPhoneSidebar: React.FC<ComponentProps> = ({ visible, onHide, phoneNumber, onComplete }) => {
  const { tr } = useTranslation();
  const [state, setState] = useState(phoneNumber);
  const { setPhoneToCurrentUser } = useContext(ApiContext);

  const validationSchema = yup.string().defined().required();

  const { clear, validationErrors, validateAndSend } = useValidation(validationSchema, () => save());

  const save = () => {
    setPhoneToCurrentUser({ phone: state }, () => {
      onComplete();
    });
  };

  return (
    <>
      {/*
        // @ts-ignore*/}
      <RingilSidebar
        visible={visible}
        size={'md'}
        heading={tr(`MyProfile.editPhoneNumber`, `Upravit telefonní číslo`)}
        onContinue={() => validateAndSend(state)}
        onBack={() => onHide()}
        continueLabel={tr(`EditPhoneSidebar.save`, `Uložit`)}
      >
        <div className="p-field p-fluid">
          <Label title={tr(`MyProfile.phoneNumber`, `Telefonní číslo`)} />
          <InputText type="tel" value={state} onChange={e => setState(e.target['value'])} />
          <ValidationDiv errors={validationErrors} path={''} />
        </div>
      </RingilSidebar>
    </>
  );
};

export default EditPhoneSidebar;
